import {AbstractPage} from "../AbstractPage";
import {JqueryApp} from "../JqueryApp";

class AllCheckedMap extends Map<string, boolean> { // (selectorPrefix, "all" checked)
    constructor() {
        super();
    }
}

export class MultiDropdown extends AbstractPage{
    protected selectorPrefix = "";
    protected allCheckedMap: AllCheckedMap;

    constructor(app: JqueryApp, selectorPrefix: string = "") {
        super(app);
        this.allCheckedMap = new AllCheckedMap();

        this.app.$(() => { // jQuery 3.0 "document.ready"
            const dropdowns = this.app.$(`${this.selectorPrefix} .multi-dropdown input[type='checkbox']`);
            if (dropdowns.length === 0)
                return;
            this.handleDropdownInit();
            dropdowns.on("change", (event) => {
                this.handleCheckboxChange(event.target);
            });
        });
    }

    // ################################################################
    // ###################### PRIVATE FUNCTIONS #######################

    protected handleDropdownInit() {
        const boxes = this.getBoxes();

        // restore checked values from hidden input
        const checkedValuesInput = (this.getValueInput().val() as string).split(",");
        boxes.each((i, el) => {
            const $el = this.app.$(el);
            if (checkedValuesInput.includes($el.attr("data-val")))
                $el.prop("checked", true);
        });
        const checkedValues = boxes.filter(":checked").map((i, el) => this.app.$(el).attr("data-val")).get();
        if (checkedValues.length === 0) {
            boxes.eq(0).prop("checked", true);
            this.getValueInput().val("");
        }

        this.handleCheckboxChange(null); // must be done after checking "all"

        // add event listeners on <a> elements
        this.app.$(`${this.selectorPrefix} .multi-dropdown .dropdown-item`).on("click", (event) => {
            const $el = this.app.$(event.target);
            const checkbox = $el.find("input[type='checkbox']");
            if (checkbox.length === 0)
                return;
            checkbox.prop("checked", !checkbox.prop("checked"));
            checkbox.trigger("change");
        });
    }

    protected handleCheckboxChange(el: HTMLElement) {
        const boxes = this.getBoxes();
        const tr = this.app.getTr();

        // check if first selected
        if (this.allCheckedMap.has(this.selectorPrefix)) { // user clicked on another element (or "all" again to uncheck)
            this.allCheckedMap.delete(this.selectorPrefix);
            if (boxes.eq(0).is(":checked"))
                boxes.eq(0).prop("checked", false);
        }
        else if (boxes.eq(0).is(":checked")) { // "all" is checked
            this.allCheckedMap.set(this.selectorPrefix, true);
            boxes.each((i, el) => {
                if (i === 0)
                    return;
                this.app.$(el).prop("checked", false); // doesn't fire change event without trigger()
            });
            this.app.$(`${this.selectorPrefix} .multi-dropdown .dropdown-title`).text(boxes.eq(0).parent(".dropdown-item").text());
            this.app.$(`${this.selectorPrefix} .multi-dropdown .dropdown-value`).text(boxes.eq(0).attr("data-val"));
            this.updateValueInput();
            return;
        }

        this.updateValueInput();
        const checkedValues = boxes.filter(":checked").map((i, el) => this.app.$(el).attr("data-val")).get();
        if (checkedValues.length > 1) {
            this.app.$(`${this.selectorPrefix} .multi-dropdown .dropdown-title`).text(checkedValues.length + " " + tr.get("selected"));
            this.app.$(`${this.selectorPrefix} .multi-dropdown .dropdown-value`).text(checkedValues.join(","));
        }
        else if (checkedValues.length === 1) {
            this.app.$(`${this.selectorPrefix} .multi-dropdown .dropdown-title`).text(boxes.filter(":checked").eq(0).parent(".dropdown-item").text());
            this.app.$(`${this.selectorPrefix} .multi-dropdown .dropdown-value`).text(checkedValues[0]);
        }
        else {
            this.app.$(`${this.selectorPrefix} .multi-dropdown .dropdown-title`).text(tr.get("select"));
            this.app.$(`${this.selectorPrefix} .multi-dropdown .dropdown-value`).text("");
        }
    }

    protected getBoxes() {
        return this.app.$(`${this.selectorPrefix} .multi-dropdown input[type='checkbox']`)
    }

    protected getValueInput() {
        return this.app.$(`${this.selectorPrefix} .multi-dropdown input[type='hidden']`);
    }

    protected updateValueInput() {
        const boxes = this.getBoxes();
        const checkedValues = boxes.filter(":checked").map((i, el) => this.app.$(el).attr("data-val")).get();
        if (checkedValues.length === 0)
            this.getValueInput().val("");
        else
            this.getValueInput().val(checkedValues.join(","));
    }
}
